import React from 'react';
import { styled } from '@compiled/react';
import PropTypes from 'prop-types';

import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import {
	AdminKeyEligibilityQuery,
	SuperAdminEntryPoint,
	AdminKeyUpSell,
} from '@confluence/super-admin';
import {
	Attribution,
	TransparentErrorBoundary,
	withErrorBoundary,
} from '@confluence/error-boundary';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SuperAdminEntry = styled.div({
	marginTop: '100px',
});
SuperAdminEntry.displayName = 'SuperAdminEntry';

const SuperAdminGatewayComponent = ({ type, contentId }) => {
	return (
		<AdminKeyEligibilityQuery>
			{({ loading, edition, canBeSuperAdmin, error }) => {
				if (loading || error) {
					return null;
				}

				if (!canBeSuperAdmin) {
					return null;
				}

				return edition === ConfluenceEdition.PREMIUM ? (
					<SuperAdminEntry>
						<SuperAdminEntryPoint type={type} contentId={contentId} />
					</SuperAdminEntry>
				) : edition === ConfluenceEdition.FREE || edition === ConfluenceEdition.STANDARD ? (
					<TransparentErrorBoundary attribution={Attribution.ADMIN_EXPERIENCE}>
						<SuperAdminEntry>
							<AdminKeyUpSell type={type} />
						</SuperAdminEntry>
					</TransparentErrorBoundary>
				) : null;
			}}
		</AdminKeyEligibilityQuery>
	);
};

SuperAdminGatewayComponent.propTypes = {
	type: PropTypes.oneOf(['page', 'space']).isRequired,
	contentId: PropTypes.string,
};

export const SuperAdminGateway = withErrorBoundary({
	attribution: Attribution.ADMIN_EXPERIENCE,
})(SuperAdminGatewayComponent);
